/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiItemViewItemGroupConfig} from "./UiItemViewItemGroupConfig";
import {UiItemViewItemBackgroundMode} from "./UiItemViewItemBackgroundMode";


export interface UiItemViewConfig extends UiComponentConfig {
	_type?: string;
	groupHeaderTemplate?: UiTemplateConfig;
	itemGroups?: {[name: string]: UiItemViewItemGroupConfig};
	horizontalPadding?: number;
	verticalPadding?: number;
	groupSpacing?: number;
	itemBackgroundMode?: UiItemViewItemBackgroundMode;
	showSelection?: boolean;
	filter?: string
}

export interface UiItemViewCommandHandler {
	setFilter(filter: string): void;
	addItemGroup(groupId: string, itemGroup: UiItemViewItemGroupConfig): void;
	refreshItemGroup(groupId: string, itemGroup: UiItemViewItemGroupConfig): void;
	removeItemGroup(groupId: string): void;
	addItem(groupId: string, item: any): void;
	removeItem(groupId: string, itemId: any): void;
	selectItem(groupId: string, itemId: any): void;
}

export interface UiItemViewEventSource {
	onItemClicked: TeamAppsEvent<UiItemView_ItemClickedEvent>;
}

export interface UiItemView_ItemClickedEvent extends UiEvent {
	_type: "UiItemView.itemClicked";
	redundancyKey?: string;
	groupId: string;
	itemId: any
}

